(function () {
  function initHavenFooter() {
    var button = document.querySelector('.haven-footer__back-to-top');
    if (!button || button.dataset.havenFooterBound === 'true') return;

    button.dataset.havenFooterBound = 'true';
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHavenFooter, { once: true });
  } else {
    initHavenFooter();
  }
})();